import React from 'react';
export function HamburgerIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.025 7.994l-16-.024a1 1 0 010-2l16 .024a1 1 0 110 2zM20.018 12.994l-16-.024a1 1 0 110-2l16 .024a1 1 0 010 2zM20.011 17.994l-16-.024a1 1 0 110-2l16 .024a1 1 0 010 2z"
  }));
}